import styled from 'styled-components';

import { GenericDiv } from 'commonStyles';

export const GetQuotePopupWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const QuoteImageBox = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 12px;
		object-fit: cover;
`;

export const MiceContainerWrapper = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
        padding: 27px 30px 0px;
        ${down(breakpoints.md)} {
           padding: 16px 14px 13px; 
        }
    `
);

export const MiceModalWrapper = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
    background: linear-gradient(#f3f3f3, #f3f3f3);
    ${down(breakpoints.md)} {
        background: linear-gradient(#f3f3f3, #f3f3f3);
    }
    `
);

export const MiceFormWrap = styled.form(
	({ theme: { down, breakpoints } }) => `
        display: flex;
				background: white;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        padding: 0px 30px 30px;
				margin-top: 16px;
        ${down(breakpoints.md)} {
            flex-direction: column;
						margin-top: 0px;
            justify-content: flex-start;
            padding: 0px 14px 24px;
        }
    `
);

export const DestinationWrapper = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
        ${down(breakpoints.md)} {
            background: #ffffff;
            padding: 11px; 
            border: 1px solid #D7D7D7;
            border-radius: 4px 4px 0 0;
        }
    `
);
